import {
    useRef,
    useImperativeHandle,
    forwardRef,
} from "react"

import DateSelector from "../DateSelector"


export default forwardRef(({ data }, ref) => {

    const fieldsData = data || {}

    const startDateRef = useRef()
    const endDateRef = useRef()

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            const startDateResult = startDateRef.current.validateAndGetData()
            const endDateResult = endDateRef.current.validateAndGetData()

            const isValid = startDateResult.isValid && endDateResult.isValid

            return {
                isValid,
                value: {
                    startDate: startDateResult.value,
                    endDate: endDateResult.value,
                },
            }
        },
    }))

    return (
        <div className="grid grid-cols-2 gap-4 my-4">
            <DateSelector title={"Start Date"} ref={startDateRef} data={fieldsData.startDate} />
            <DateSelector title={"End Date"} ref={endDateRef} data={fieldsData.endDate} />
        </div>
    )
})
